import * as React from 'react';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
    icon: React.ReactNode;
    title: string;
    description?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({icon, title, description}) => (
    <div className={styles.emptyState}>
        <div className={styles.emptyState__icon}>{icon}</div>
        <div className={styles.emptyState__title}>{title}</div>
        {description && <div className={styles.emptyState__description}>{description}</div>}
    </div>
);
